export default __webpack_public_path__ + "static/what-fit_croped-01aacee9e300d60959aefa63be9a4d0f.jpg";